// src/confluence/database/types.ts
var ConfluenceDatabaseAriResourceOwner = "confluence", ConfluenceDatabaseAriResourceType = "database";

export {
  ConfluenceDatabaseAriResourceOwner,
  ConfluenceDatabaseAriResourceType
};
